import axios, { AxiosInstance } from "axios";

const base64Credentials = btoa(`${process.env.REACT_APP_USER_NAME}:${process.env.REACT_APP_USER_PASS}`);

/**
 * authApi
 *
 * نمونه‌ای از axios برای ارسال درخواست‌های احراز هویت‌شده با Basic Auth.
 *
 * این ماژول به‌طور خودکار اطلاعات ورود (username و password) را به فرمت Base64 تبدیل کرده
 * و در هدر Authorization قرار می‌دهد.
 *
 * ویژگی‌ها:
 * - اتصال امن با Basic Authentication
 * - هدر پیش‌فرض Content-Type: application/json
 * - استفاده از متغیر محیطی REACT_APP_API_BASE_URL برای تنظیم baseURL
 *
 * مثال استفاده:
 * ```ts
 * import authApi from "@/api/authApi";
 * const response = await authApi.get("/user/profile");
 * ```
 */
const authApi: AxiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  headers: {
    Authorization: `Basic ${base64Credentials}`,
    "Content-Type": "application/json",
  },
});

export default authApi;
